'use client';

import { useCookies } from 'next-client-cookies';
import { Product } from 'shared/types/product/Product';
import ProductSlider, { ProductSliderProps } from 'components/commercetools-ui/organisms/product/product-slider';
import { mapProduct } from 'helpers/entity-mappers/map-product';
import { DataSource } from 'types/datasource';
import { useCart, useWishlist } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';

function ProductSliderTastic({ data }: TasticProps<DataSource<{ items: Product[] }> & ProductSliderProps>) {
  const cookies = useCookies();
  const locale = cookies.get('locale') as string;

  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();

  const { addItem, shippingMethods } = useCart();

  if (!data?.data?.dataSource?.items) return <p>No products found.</p>;

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mobile, tablet, desktop, ...props } = data;

  return (
    <ProductSlider
      {...props}
      wishlist={wishlist}
      products={data.data.dataSource.items.map((product) => mapProduct(product, { locale }))}
      shippingMethods={shippingMethods.data}
      onAddToCart={addItem}
      addToWishlist={async (lineItem, count) => {
        if (wishlist) await addToWishlist(wishlist, lineItem, count);
      }}
      removeLineItem={async (lineItem) => {
        if (wishlist) await removeLineItem(wishlist, lineItem);
      }}
    />
  );
}

export default ProductSliderTastic;
